<style lang="less">
.vip_service {
  .cursor {
    cursor: pointer;
  }
  max-width: 1440px;
  width:100%;
  margin: 0 auto;
  height: auto;
  position: relative;
  .topBg {
    width: 100%;
    height: 195px;
    // padding: 45px 210px;
    display: flex;
	align-items: center;
    justify-content: space-around;
    position: relative;
    > div {
      color: #fff;
      text-align: left;
      > span {
        display: inline-block;
        padding: 0 0 13px;
        border-bottom: 1px solid #fff;
        font-size: 18px;
      }
      > p {
        margin-top: 16px;
        font-size: 24px;
      }
	  @media screen and (max-width:500px ) {
	  	> span {
	  	  font-size: 14px;
	  	}
	  	> p {
	  	  font-size: 18px;
		  text-align: center;
	  	}
	  }
    }
    > img {
      // position: absolute;
      // top: 10px;
      // right: 210px;
	  position: relative;
	  top:15px
    }
	@media screen and (max-width:1000px ) {
		> img {
		  display: none;
		}
	}
  }
  .vip_top {
    width: 100%;
    height: 793px;
    position: relative;
    top: 0;
    left: 0;
    z-index: 1;
    padding: 50px 0 0;

    .vip_intro {
      width: 320px;
      margin: 0 auto;

      .vip_introTile {
        width: 320px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        background: rgba(180, 139, 89, 1);
        border-radius: 45px;
        color: #fff;
        font-size: 28px;

        span {
          font-size: 34px;
        }
      }

      > ul {
        margin: 60px 0;

        li {
          padding: 15px 0;
          font-size: 22px;
          color: #f6f6f6;
          text-align: center;
        }
      }

      .more_vipService {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #d2bda3;
        font-size: 26px;
      }
    }

    .vip_cards {
      max-width: 1290px;
	  width:100%;
	  // min-width:860px;
      height: 260px;
      position: relative;
      // margin: 0px auto 0;
      z-index: 2;

      display: flex;
      justify-content: space-between;
	  @media screen and (max-width:500px ) {
	  	flex-wrap: wrap;
	  }
      // display: grid;
      // grid-template-columns: 1fr 1fr;
      // row-gap: 50px;

      > div {
        width: 580px;
        height: 100%;
        padding: 27px 80px;
        text-align: left;
        color: #484848;
        position: relative;

        p {
          font-size: 20px;

          span {
            font-size: 26px;
            font-weight: bold;
            display: inline-block;
            margin-right: 13px;
          }
        }

        ul {
          font-size: 18px;
          margin-top: 34px;
		@media screen and (max-width:500px ) {
			 font-size: 15px;
		}
          li {
            list-style: none;
            padding: 6px 0;
          }
        }
        .card_tips {
          height: 40px;
          padding: 0 7px;
          display: inline-block;
          border: 1px solid #14120d;
          opacity: 0.8;
          width: auto;
          border-radius: 8px;
          line-height: 40px;

          font-size: 18px;
          font-weight: 500;

          color: #14120d;
        }
        > .buy_Btn {
          position: absolute;
          right: 40px;
          bottom: 30px;
          font-size: 20px;
          display: flex;
          align-items: center;

          span {
            display: inline-block;
            margin-left: 8px;
          }
        }
      }
		@media screen and (max-width:850px ) {
			> div {
				transform: scale(0.7);
				transform-origin:34% 10%;
				min-width:416px;
			}
		}
      // margin-right: ;
    }
  }
  .rightBottomImg {
    position: absolute;
    right: -230px;
    bottom: 0;
  }

  .rightBigRing {
    width: 238px;
    height: 238px;
    background-color: #e6ebff;
    border-radius: 50%;
    position: absolute;
    right: -180px;
    top: 260px;
  }
  .rightBorderRing {
    position: absolute;
    right: -200px;
    top: 200px;
    width: 67px;
    height: 67px;
    border-radius: 50%;
    border: 4px solid #ffe1be;
  }
  @media screen and (max-width:1000px ) {
  	.rightBottomImg ,.rightBigRing,.rightBorderRing{
  	  display: none;
  	}
  }
  .vip_bottom {
    width: 100%;
    height: 379px;
    position: relative;
    margin-top: -100px;
    img {
      height: 100%;
      width: 100%;
    }
  }
}
.mask_box {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
  background-color: rgba(51, 51, 51, 0.5);
  .mask_content_box {
    width: 260px;
    height: 170px;
    background-color: rgba(247, 248, 250, 1);
    border-radius: 10px;
    margin: 0 auto;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    padding-top: 20px;
    > div {
      &:nth-child(1) {
        width: 100%;
        height: 22px;
        margin: 0 auto 12px;
        font-size: 20px;
        color: rgba(51, 51, 51, 1);
        font-weight: bold;
      }
      &:nth-child(2) {
        width: 100%;
        margin: 0 auto 18px;
        p {
          font-size: 16px;
          color: rgba(51, 51, 51, 1);
          &:nth-child(2) {
            font-size: 15px;
            margin-top: 8px;
          }
        }
      }
      &:nth-child(3) {
        text-align: center;
        height: 50px;
        line-height: 50px;
        border-top: 1px solid rgba(224, 224, 224, 1);
        color: rgba(255, 124, 0, 1);
      }
    }
  }
}
.buy_Btn img {
  width: 30px;
  height: 30px;
}
  @media screen and (max-width:500px ) {
  	.el-dialog{
		width:80% !important;
	}
  }
</style>
<template>
  <div>
    <div class="vip_service" v-show="!CardsShow">
      <div
        class="topBg"
        :style="{
          background: 'url(' + headBack + ')',
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
        }"
      >
        <div>
          <span>柜柜云仓，全球板材工业物联网：全国5大总仓，2大海外仓</span>
          <p>1张起售，就近发货，包退包换</p>
        </div>
        <img src="../../assets/index_bg4.png" alt="" />
      </div>
      <div class="vip_top">
        <div class="vip_intro">
          <!-- <div class="vip_introTile">加入云仓，共同成长</div> -->
          <!--          <ul>
            <li>1.统一会员价，无条件退货</li>
            <li>2.品质有保障，物流超期赔付</li>
            <li>3.信用良好者,可以先赊账</li>
          </ul>
          <div class="more_vipService cursor" @click="gotoProduct">更多会员增值服务&nbsp;<img src="../../assets/right_icon.png"
              alt=""></div> -->
        </div>

        <!-- <div class="vip_cards">
          <div v-for="item in cards.slice(2)" :key="item.id" :style="{background:'url('+item.bg+') no-repeat',color:item.color,'background-size':'100% 100%'}">
            <p style="color:#E62800;font-weight:bold;"><span :style="{color:item.color}">{{item.title}}</span>￥{{item.price}}</p>
            <ul :style="{marginTop:item.goHome?'40px':'20px'}">
              <li v-for="(value,index) in item.include" :key="index">{{index+1}}.{{value}}</li>
            </ul>
            <div class="cursor buy_Btn" @click="BuyVip(item.id)"><img :src="item.buyBtn" alt=""><span>加入会员</span></div>
          </div>
        </div> -->
        <div class="vip_cards">
          <div
            v-for="(item, index) in cards"
            :key="item.id"
            :style="{
              background: 'url(' + item.bg + ') no-repeat',
              color: item.color,
              'background-size': '100% 100%',
            }"
            style="height: 300px"
          >
            <p style="color: #e62800; font-weight: bold">
              <span :style="{ color: item.color }">{{ item.title }}</span>
              <span v-if="item.price"
                >{{ "￥" + item.price
                }}{{ item.id == 24 || item.id == 26 ? "+" : "" }}</span
              >
            </p>
            <span v-if="item.goHome">{{ item.goHome }}</span>
            <ul :style="{ marginTop: item.goHome ? '40px' : '5px' }">
              <li v-for="(value, index) in item.include" :key="index">
                {{ index + 1 }}.{{ value }}
              </li>
            </ul>
            <div class="cursor buy_Btn" @click="application(item)">
              <img :src="item.buyBtn" alt="" /><span>{{ item.btnValue }}</span>
            </div>
            <!-- <div class="cursor buy_Btn" v-if="item.btnValue == '加入会员'" @click="BuyVip(item.id)"><img :src="item.buyBtn" alt=""><span>{{item.btnValue}}</span></div> -->
            <div class="card_tips" v-if="item.tips">{{ item.tips }}</div>
          </div>
        </div>
      </div>
      <!-- <div class="vip_bottom"><img src='../../assets/wave.png' alt=""></div> -->
      <div class="rightBottomImg">
        <img src="../../assets/addCloudRight.png" alt="" />
      </div>
      <div class="rightBigRing"></div>
      <div class="rightBorderRing"></div>
    </div>
    <el-dialog title="加盟服务网点" :visible.sync="serviceFormVisible">
      <el-form :model="serviceForm" ref="serviceForm" label-width="80px" :rules="rules">
        <el-form-item label="定制家具">
          <el-checkbox-group
            v-model="serviceForm.furniture"
            style="text-align: left"
          >
            <el-checkbox
              :label="item.id"
              v-for="item in serviceTypeOptions.furniture"
              :key="item.id"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="定制门窗">
          <el-checkbox-group
            v-model="serviceForm.doorwindow"
            style="text-align: left"
          >
            <el-checkbox
              :label="item.id"
              v-for="item in serviceTypeOptions.doorwindow"
              :key="item.id"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="定制木门">
          <el-checkbox-group
            v-model="serviceForm.wooddoor"
            style="text-align: left"
          >
            <el-checkbox
              :label="item.id"
              v-for="item in serviceTypeOptions.wooddoor"
              :key="item.id"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="网点名">
          <el-input v-model="serviceForm.name"></el-input>
        </el-form-item>
        <el-form-item label="所在城市" style="text-align: left">
          <el-cascader
            :options="provinceAndCityDataOptions"
            v-model="serviceForm.city"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="社区地址">
          <el-input v-model="serviceForm.address"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="serviceForm.userName"></el-input>
        </el-form-item>
        <el-form-item label="工龄">
          <el-input v-model="serviceForm.workAge"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="serviceForm.phone"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="serviceFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('serviceForm')"
          >提 交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="加盟云工厂" :visible.sync="factoryFormVisible">
      <el-form :model="factoryForm" label-width="80px" ref="factoryForm" :rules="rules">
        <el-form-item label="选择行业" style="text-align: left">
          <el-radio-group v-model="factoryForm.type">
            <el-radio
              v-for="item in factoryTypeOptions"
              :key="item.id"
              :label="item.id"
              >{{ item.value }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <el-form-item label="所在城市" style="text-align: left">
          <el-cascader
            :options="provinceAndCityDataOptions"
            v-model="factoryForm.city"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="工厂地址">
          <el-input v-model="factoryForm.address"></el-input>
        </el-form-item>
        <el-form-item label="品牌名称">
          <el-input v-model="factoryForm.userName"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="factoryForm.phone"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="factoryFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('factoryForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <CloudVip
      v-if="CardsShow"
      @back="goBack"
      :buyId="buyId"
      @toCenter="toCenter"
    ></CloudVip>
  </div>
</template>
<script>
import CloudVip from "../../components/cloud/CloudVip";
import { mapState } from "vuex";
import { provinceAndCityData, CodeToText } from "element-china-area-data";
import {checkCellPhone} from '../../util/utils.js';

export default {
  components: {
    CloudVip,
  },
  computed: {
    ...mapState({
      userData: "userInfo",
    }),
  },
  data() {
    return {
      rules: {
        phone: [{
          validator: checkCellPhone,
          trigger: 'blur'
        }, {
          require: true
        }]
      },
      provinceAndCityDataOptions: provinceAndCityData,
      serviceTypeOptions: {
        doorwindow: [],
        wooddoor: [],
        furniture: []
      }, // 服务商经营项目
      factoryTypeOptions: [], // 云工厂经营项目
      factoryForm: {
        type: [],
        city: "",
        province: "",
        address: "",
        userName: "",
        phone: "",
      },
      serviceForm: {
        furniture: [],
        doorwindow: [],
        wooddoor: [],
        workAge: '',
        name: "",
        city: "",
        province: "",
        address: "",
        userName: "",
        phone: "",
      },
      serviceFormVisible: false,
      factoryFormVisible: false,
      maskShow: false,
      maskTitle: "",
      headBack: require("../../assets/index_bg1.png"),
      Back: require("../../assets/Back.png"),
      cards: [
        {
          id: 1,
          title: "加盟服务网点",
          price: "5800",
          goHome: "",
          exp: "终生",
          include: [
            "平台派单，测量安装",
            "赠送测量软件、门窗柜设计、户型设计软件、柜体设计软件",
            "每个社区仅限1名",
          ],
          color: "#484848",
          bg: require("../../assets/gold_pc@2x.png"),
          buyBtn: require("../../assets/wood_buy.png"),
          btnValue: "申请加入",
        },
        {
          id: 2,
          title: "加盟云工厂",
          price: "5000.00",
          goHome: "",
          exp: "终生",
          include: [
            "平台派单，解决获客难的问题",
            "柜柜云仓、门窗云仓就近供货，无需备库存",
            "产品设计、拆单算料、工厂管理软件赋能",
          ],
          color: "#444444",
          bg: require("../../assets/gongying.png"),
          buyBtn: require("../../assets/wood_buy.png"),
          btnValue: "申请加入",
        },
      ],
      CardsShow: false,
      // userData:{},
      buyId: -1,
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return;
        }
        const formData = this[formName];
        let payload = {};
        let url = '';
        switch (formName) {
          case 'serviceForm':
            url = '/py/erp/apply_service_outlets';
            payload = {
              project_part: formData.furniture.concat(formData.doorwindow).concat(formData.wooddoor),
              province: formData.city[0] ? CodeToText[formData.city[0]] : '',
              city: formData.city[1] ? CodeToText[formData.city[1]] : '',
              phone: formData.phone,
              store_name: formData.name,
              address: formData.address,
              name: formData.userName,
              work_years: formData.workAge
            }
            break;
          case 'factoryForm':
            url = '/py/erp/apply_cloud_factory';
            payload = {
              phone: formData.phone,
              brand_name: formData.userName,
              province: formData.city[0] ? CodeToText[formData.city[0]] : '',
              city: formData.city[1] ? CodeToText[formData.city[1]] : '',
              address: formData.address,
              project_part: [formData.type]
            };
            break;
          default:
            break;
        }
        this.$requests.submitApplyForServiceAndFactory(url, payload).then((res) => {
          this.$message.success('申请提交成功，请等待审核');
          this[`${formName}Visible`] = false;
        }).catch((err) => {
          this.$message.error(err);
        })
      });
    },
    getServiceTypeOptions() {
      this.$requests.getServiceTypeOptions().then((res) => {
        this.serviceTypeOptions = res;
      });
    },
    getFactoryTypeOptions() {
      this.$requests.getFactoryTypeOptions().then((res) => {
        this.factoryTypeOptions = res;
      });
    },
    application(option) {
      switch (option.id) {
        case 1:
          this.serviceFormVisible = true;
          break;
        case 2:
          this.factoryFormVisible = true;
          break;
        default:
          break;
      }
    },
    hideMask(event) {
      let event1 = event.currentTarget;
      let event2 = event.target;
      if (event1 == event2) {
        this.maskShow = false;
      }
    },
    copyNumber() {
      let input = document.getElementById("input");
      input.value = "15358019840";
      input.select();
      document.execCommand("copy");
      this.$message({
        message: "复制成功",
        type: "success",
      });
      this.maskShow = false;
    },
    // 购买会员后跳转到个人中心
    toCenter(value) {
      this.$emit("changeNow", value);
    },
    goBack() {
      this.CardsShow = false;
    },
    BuyVip(cardId) {
      let id = cardId;
      if (!localStorage.data) {
        let pageTo = encodeURIComponent(location.href);
        location.href =
          "https://www.guigui.com.cn/login.html?other=true&pageTo=" + pageTo;
        // location.href='./login.html?pageTo='+pageTo
        // this.$emit('logon')
      }
      if (this.userData.cloud_vip == 2 && id == 22) {
        this.$message("您已是代理，请勿重复开通");
        return;
      }
      if (this.userData.cloud_vip >= 1) {
        if (id == 21) {
          this.$message("您已是云仓会员，请勿重复开通");
          return;
        }
        // if (id == 22) {
        //   this.$message("暂不支持升级成黄金会员")
        //   return
        // }
      }
      // if (this.userData.cloud_vip == 0 && this.userData.vip != 0) {
      //   if (id == 22) {
      //     this.$message("暂不支持升级成黄金会员")
      //     return
      //   }
      // }
      if (
        this.userData.vip == 1 &&
        (!this.userData.clout_vip || this.userData.clout_vip == 0) &&
        id == 21
      ) {
        this.buyId = 20;
        console.log(this.buyId);
      } else {
        this.buyId = cardId;
        console.log(this.buyId);
      }
      this.CardsShow = true;
    },
    gotoProduct() {
      if (localStorage.data) {
        // this.axios.post('https://guigui.admin.thinkerx.com/eggrj/getEnP', {
        //   phone: this.userData.phone,
        //   uid: this.userData.id
        // }).then(res => {
        //   if (res.data.data) {
        //     window.open('http://eggrj.com/product.html?' + res.data.data)
        //   } else {
        //     window.open('http://eggrj.com/product.html')
        //   }
        // })
        this.$post(
          "/system/eggrj/getEnP",
          {
            phone: this.userData.phone,
            uid: this.userData.id,
          },
          (res) => {
            if (res.data) {
              window.open("http://eggrj.com/product.html?" + res.data);
            } else {
              window.open("http://eggrj.com/product.html");
            }
          }
        );
      } else {
        window.open("http://eggrj.com/product.html");
      }
    },
  },
  mounted() {
    // this.$get("/guigui/price/getAppPrice", {}, (res) => {
    //   let price = res.data;
    //   // console.log('pc',price)
    //   for (let i = 0, len = price.length; i < len; i++) {
    //     if (price[i].id == 21) {
    //       // 云仓会员没有价格了
    //       // this.cards[0].title = price[i].type
    //       // this.cards[0].price = price[i].price
    //       // this.cards[0].exp = price[i].unit
    //     }
    //     if (price[i].id == 23) {
    //       // this.cards[1].title = price[i].type
    //       this.cards[1].price = price[i].price;
    //       this.cards[1].exp = price[i].unit;
    //     }
    //     if (price[i].id == 24) {
    //       this.cards[2].price = price[i].price;
    //       this.cards[2].exp = price[i].unit;
    //     }
    //     if (price[i].id == 26) {
    //       this.cards[3].price = price[i].price;
    //       this.cards[3].exp = price[i].unit;
    //     }
    //   }
    // });
  },
  created() {
    this.getServiceTypeOptions();
    this.getFactoryTypeOptions();
  },
};
</script>
